define('models/advertiserRemoteAccount',["T1", "T1Model", "Backbone"], function (T1, T1Model, Backbone) {
  T1.Models.AdvertiserRemoteAccount = T1Model.extend({
    url: "advertisers",
    fixture: "-Advertisers"
  });
  return T1.Models.AdvertiserRemoteAccount;
});
